"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseList = void 0;
const ramda_1 = require("ramda");
const SIZE = 6;
const parseList = (list, sortPropName) => (0, ramda_1.splitEvery)(SIZE, (0, ramda_1.sortBy)((0, ramda_1.compose)(ramda_1.toLower, (0, ramda_1.prop)(sortPropName)))(list));
exports.parseList = parseList;
